import { useQuery } from '@tanstack/react-query'
import { getInquiryAssigns } from '@/lib/apiClients/inquiries'
import { queryKeys } from '@/lib/queryKeys'

export function useInquiryAssigns(inquiryId: number) {
  return useQuery({
    queryKey: queryKeys.inquiry.assigns(inquiryId),
    queryFn: async () => {
      return getInquiryAssigns(inquiryId)
    },
    enabled: inquiryId > 0,
  })
}
